<ng-container [formGroup]="metadataFormGroup">
  <app-shared-business-form
    [formGroup]="sharedBusinessFormGroup"
    [showStaffFields]="true"
    [showActivityFields]="true"
  />

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Informations RC Entreprise
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Franchise (CHF)</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="reimbursedSum"
      />
    </div>
    <div class="col">
      <label i18n>Somme d'assurance (CHF)</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="insuredSum"
      />
    </div>
  </div>

  <div class="row row-cols-1 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Couvertures supplémentaires</label>
      <mat-form-field class="lty-input">
        <mat-select
          [formControl]="
            getControl(metadataFormGroup.controls['additionalCovers'])
          "
          multiple
        >
          <mat-option
            *ngFor="let cover of additionalCoverValues"
            [value]="cover"
          >
            {{ getRcCompanyAdditionalCoverLabel(cover) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Prestations assurées
  </div>
  <div class="row row-cols-md-1 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Validité temporelle</label>
      <mat-form-field class="lty-input">
        <mat-select formControlName="coverageValidityDuration">
          <mat-option
            *ngFor="let validity of coverageValidityValues"
            [value]="validity"
          >
            {{ getBusinessRcCompanyCoverageValidityLabel(validity) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Dommages corporels et matériels
  </div>
  <ng-container formGroupName="companyPersonalDamageCoverage">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Dommages aux biens personnels</label>
        <div class="form-check">
          <input
            type="radio"
            name="personalPropertyDamage"
            id="personalPropertyDamageFalse"
            [value]="false"
            formControlName="personalPropertyDamage"
          />
          <label class="form-check-label" for="personalPropertyDamageFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="personalPropertyDamage"
            id="personalPropertyDamageTrue"
            [value]="true"
            formControlName="personalPropertyDamage"
          />
          <label class="form-check-label" for="personalPropertyDamageTrue"
            >Oui</label
          >
        </div>
      </div>
      <div class="col">
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuredSum"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Double garantie</label>
        <div class="form-check">
          <input
            type="radio"
            name="doubleWarranty"
            id="doubleWarrantyFalse"
            [value]="false"
            formControlName="doubleWarranty"
          />
          <label class="form-check-label" for="doubleWarrantyFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="doubleWarranty"
            id="doubleWarrantyTrue"
            [value]="true"
            formControlName="doubleWarranty"
          />
          <label class="form-check-label" for="doubleWarrantyTrue">Oui</label>
        </div>
      </div>
      <div class="col">
        <label i18n>Franchise DC</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="dcFranchise"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Franchise DM</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="dmFranchise"
        />
      </div>
      <div class="col">
        <label i18n>Préjudices de fortune</label>
        <div class="form-check">
          <input
            type="radio"
            name="financialLoss"
            id="financialLossFalse"
            [value]="false"
            formControlName="financialLoss"
          />
          <label class="form-check-label" for="financialLossFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="financialLoss"
            id="financialLossTrue"
            [value]="true"
            formControlName="financialLoss"
          />
          <label class="form-check-label" for="financialLossTrue">Oui</label>
        </div>
      </div>
    </div>

    <div
      class="row row-cols-md-3 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('companyPersonalDamageCoverage.financialLoss')
          ?.value === 'true' ||
        metadataFormGroup.get('companyPersonalDamageCoverage.financialLoss')
          ?.value === true
      "
    >
      <div class="col">
        <label i18n>Somme d'assurance en PF</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="financialLossInsuredSum"
        />
      </div>
      <div class="col">
        <label i18n>Franchise en PF</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="financialLossDeductible"
        />
      </div>
      <div class="col">
        <label i18n
          >Couverture en PF sur la violation des lois sur la protection des
          données</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="financialLossDataViolationCoverage"
            id="financialLossDataViolationCoverageFalse"
            [value]="false"
            formControlName="financialLossDataViolationCoverage"
          />
          <label
            class="form-check-label"
            for="financialLossDataViolationCoverageFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="financialLossDataViolationCoverage"
            id="financialLossDataViolationCoverageTrue"
            [value]="true"
            formControlName="financialLossDataViolationCoverage"
          />
          <label
            class="form-check-label"
            for="financialLossDataViolationCoverageTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>
  </ng-container>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Dommages environnementaux
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div formGroupName="environmentDamageBasicCoverage" class="col">
      <label class="form-subtitle-small mb-2" i18n
        >Atteinte à l'environnement : base</label
      >
      <div class="form-check mb-2">
        <input
          type="radio"
          id="envBasicWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="envBasicWithCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check mb-2">
        <input
          type="radio"
          id="envBasicWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="envBasicWithCoverageTrue"
          >Oui</label
        >
      </div>
      <div
        *ngIf="
          metadataFormGroup.get('environmentDamageBasicCoverage.withCoverage')
            ?.value === 'true' ||
          metadataFormGroup.get('environmentDamageBasicCoverage.withCoverage')
            ?.value === true
        "
      >
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
    <div formGroupName="environmentDamageExtendedCoverage" class="col">
      <label class="form-subtitle-small mb-2" i18n
        >Atteinte à l'environnement : étendue</label
      >
      <div class="form-check mb-2">
        <input
          type="radio"
          id="envExtendedWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="envExtendedWithCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check mb-2">
        <input
          type="radio"
          id="envExtendedWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="envExtendedWithCoverageTrue"
          >Oui</label
        >
      </div>
      <div
        *ngIf="
          metadataFormGroup.get(
            'environmentDamageExtendedCoverage.withCoverage'
          )?.value === 'true' ||
          metadataFormGroup.get(
            'environmentDamageExtendedCoverage.withCoverage'
          )?.value === true
        "
      >
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Frais de prévention des dommages
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div formGroupName="damagePreventionCoverage" class="col">
      <label i18n>Frais de prévention de dommages</label>
      <div class="form-check">
        <input
          type="radio"
          id="damagePreventionWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="damagePreventionWithCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="damagePreventionWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="damagePreventionWithCoverageTrue"
          >Oui</label
        >
      </div>
      <div
        *ngIf="
          metadataFormGroup.get('damagePreventionCoverage.withCoverage')
            ?.value === 'true' ||
          metadataFormGroup.get('damagePreventionCoverage.withCoverage')
            ?.value === true
        "
      >
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
    <div formGroupName="misappropriationDamageCoverage" class="col">
      <label i18n>Dommages de malversations</label>
      <div class="form-check">
        <input
          type="radio"
          id="misappropriationWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="misappropriationWithCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="misappropriationWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="misappropriationWithCoverageTrue"
          >Oui</label
        >
      </div>
      <div
        *ngIf="
          metadataFormGroup.get('misappropriationDamageCoverage.withCoverage')
            ?.value === 'true' ||
          metadataFormGroup.get('misappropriationDamageCoverage.withCoverage')
            ?.value === true
        "
      >
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div formGroupName="reputationRestorationCoverage" class="col">
      <label i18n>Frais de rétablissement de la réputation</label>
      <div class="form-check">
        <input
          type="radio"
          id="reputationRestorationWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label
          class="form-check-label"
          for="reputationRestorationWithCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="reputationRestorationWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label
          class="form-check-label"
          for="reputationRestorationWithCoverageTrue"
          >Oui</label
        >
      </div>
      <div
        *ngIf="
          metadataFormGroup.get('reputationRestorationCoverage.withCoverage')
            ?.value === 'true' ||
          metadataFormGroup.get('reputationRestorationCoverage.withCoverage')
            ?.value === true
        "
      >
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
    <div formGroupName="structureDamagesCoverage" class="col">
      <label i18n>Dommages aux ouvrages</label>
      <div class="form-check">
        <input
          type="radio"
          id="structureDamagesWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="structureDamagesWithCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="structureDamagesWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="structureDamagesWithCoverageTrue"
          >Oui</label
        >
      </div>
      <div
        *ngIf="
          metadataFormGroup.get('structureDamagesCoverage.withCoverage')
            ?.value === 'true' ||
          metadataFormGroup.get('structureDamagesCoverage.withCoverage')
            ?.value === true
        "
      >
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Importateur assuré</label>
      <div class="form-check">
        <input
          type="radio"
          name="importerInsured"
          id="importerInsuredFalse"
          [value]="false"
          formControlName="importerInsured"
        />
        <label class="form-check-label" for="importerInsuredFalse">Non</label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="importerInsured"
          id="importerInsuredTrue"
          [value]="true"
          formControlName="importerInsured"
        />
        <label class="form-check-label" for="importerInsuredTrue">Oui</label>
      </div>
    </div>
    <div class="col">
      <label i18n>Biens immatériels</label>
      <div class="form-check">
        <input
          type="radio"
          name="intangibleAssets"
          id="intangibleAssetsFalse"
          [value]="false"
          formControlName="intangibleAssets"
        />
        <label class="form-check-label" for="intangibleAssetsFalse">Non</label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="intangibleAssets"
          id="intangibleAssetsTrue"
          [value]="true"
          formControlName="intangibleAssets"
        />
        <label class="form-check-label" for="intangibleAssetsTrue">Oui</label>
      </div>
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Codes à barres EAN</label>
      <div class="form-check">
        <input
          type="radio"
          name="eanBarcodes"
          id="eanBarcodesFalse"
          [value]="false"
          formControlName="eanBarcodes"
        />
        <label class="form-check-label" for="eanBarcodesFalse">Non</label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="eanBarcodes"
          id="eanBarcodesTrue"
          [value]="true"
          formControlName="eanBarcodes"
        />
        <label class="form-check-label" for="eanBarcodesTrue">Oui</label>
      </div>
    </div>
    <div class="col">
      <label i18n>Rayonnement ionisant et laser</label>
      <div class="form-check">
        <input
          type="radio"
          name="ionizingRadiation"
          id="ionizingRadiationFalse"
          [value]="false"
          formControlName="ionizingRadiation"
        />
        <label class="form-check-label" for="ionizingRadiationFalse">Non</label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="ionizingRadiation"
          id="ionizingRadiationTrue"
          [value]="true"
          formControlName="ionizingRadiation"
        />
        <label class="form-check-label" for="ionizingRadiationTrue">Oui</label>
      </div>
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Combinaison d'installation de transport à câbles</label>
      <div class="form-check">
        <input
          type="radio"
          name="cableTransportInstallationCombination"
          id="cableTransportInstallationCombinationFalse"
          [value]="false"
          formControlName="cableTransportInstallationCombination"
        />
        <label
          class="form-check-label"
          for="cableTransportInstallationCombinationFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="cableTransportInstallationCombination"
          id="cableTransportInstallationCombinationTrue"
          [value]="true"
          formControlName="cableTransportInstallationCombination"
        />
        <label
          class="form-check-label"
          for="cableTransportInstallationCombinationTrue"
          >Oui</label
        >
      </div>
    </div>
    <div class="col">
      <label i18n>Envoi d'articles d'incendie ou d'explosion</label>
      <div class="form-check">
        <input
          type="radio"
          name="firefightingExplosiveMaterialShipping"
          id="firefightingExplosiveMaterialShippingFalse"
          [value]="false"
          formControlName="firefightingExplosiveMaterialShipping"
        />
        <label
          class="form-check-label"
          for="firefightingExplosiveMaterialShippingFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="firefightingExplosiveMaterialShipping"
          id="firefightingExplosiveMaterialShippingTrue"
          [value]="true"
          formControlName="firefightingExplosiveMaterialShipping"
        />
        <label
          class="form-check-label"
          for="firefightingExplosiveMaterialShippingTrue"
          >Oui</label
        >
      </div>
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div formGroupName="buildingCoverage" class="col">
      <label i18n
        >Bâtiment servant ou non qu'à l'entreprise ainsi qu'en PPE</label
      >
      <div class="form-check">
        <input
          type="radio"
          id="buildingWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="buildingWithCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="buildingWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="buildingWithCoverageTrue"
          >Oui</label
        >
      </div>
      <div
        *ngIf="
          metadataFormGroup.get('buildingCoverage.withCoverage')?.value ===
            'true' ||
          metadataFormGroup.get('buildingCoverage.withCoverage')?.value === true
        "
      >
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
    <div formGroupName="itemsCoverage" class="col">
      <label i18n>Choses prises en charges</label>
      <div class="form-check">
        <input
          type="radio"
          id="itemsWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="itemsWithCoverageFalse">Non</label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="itemsWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="itemsWithCoverageTrue">Oui</label>
      </div>
      <div
        *ngIf="
          metadataFormGroup.get('itemsCoverage.withCoverage')?.value ===
            'true' ||
          metadataFormGroup.get('itemsCoverage.withCoverage')?.value === true
        "
      >
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div formGroupName="cisternCoverage" class="col">
      <label i18n>Citerne</label>
      <div class="form-check">
        <input
          type="radio"
          id="cisternWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="cisternWithCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="cisternWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="cisternWithCoverageTrue"
          >Oui</label
        >
      </div>
      <div
        *ngIf="
          metadataFormGroup.get('cisternCoverage.withCoverage')?.value ===
            'true' ||
          metadataFormGroup.get('cisternCoverage.withCoverage')?.value === true
        "
      >
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
    <div formGroupName="installationAssemblyCoverage" class="col">
      <label i18n>Combinaison installation/montage</label>
      <div class="form-check">
        <input
          type="radio"
          id="installationAssemblyWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label
          class="form-check-label"
          for="installationAssemblyWithCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="installationAssemblyWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label
          class="form-check-label"
          for="installationAssemblyWithCoverageTrue"
          >Oui</label
        >
      </div>
      <div
        *ngIf="
          metadataFormGroup.get('installationAssemblyCoverage.withCoverage')
            ?.value === 'true' ||
          metadataFormGroup.get('installationAssemblyCoverage.withCoverage')
            ?.value === true
        "
      >
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div formGroupName="workingCommunitiesCoverage" class="col">
      <label i18n>Communautés de travail/Consortium</label>
      <div class="form-check">
        <input
          type="radio"
          id="workingCommunitiesWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label
          class="form-check-label"
          for="workingCommunitiesWithCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="workingCommunitiesWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="workingCommunitiesWithCoverageTrue"
          >Oui</label
        >
      </div>
      <div
        *ngIf="
          metadataFormGroup.get('workingCommunitiesCoverage.withCoverage')
            ?.value === 'true' ||
          metadataFormGroup.get('workingCommunitiesCoverage.withCoverage')
            ?.value === true
        "
      >
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
    <div formGroupName="workedObjectBasicCoverage" class="col">
      <label i18n>Couverture de l'objet travaillé : base</label>
      <div class="form-check">
        <input
          name="withCoverage"
          type="radio"
          id="workedObjectBasicWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="workedObjectBasicWithCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          name="withCoverage"
          type="radio"
          id="workedObjectBasicWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label class="form-check-label" for="workedObjectBasicWithCoverageTrue"
          >Oui</label
        >
      </div>
      <div
        *ngIf="
          metadataFormGroup.get('workedObjectBasicCoverage.withCoverage')
            ?.value === 'true' ||
          metadataFormGroup.get('workedObjectBasicCoverage.withCoverage')
            ?.value === true
        "
      >
        <label i18n>Somme d'assurance (CHF)</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise (CHF)</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
  </div>

  <div class="row my-3">
    <div formGroupName="workedObjectExtendedCoverage" class="col">
      <label i18n>Couverture de l'objet travaillé : élargie</label>
      <div class="form-check">
        <input
          type="radio"
          id="workedObjectExtendedWithCoverageFalse"
          [value]="false"
          formControlName="withCoverage"
        />
        <label
          class="form-check-label"
          for="workedObjectExtendedWithCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="workedObjectExtendedWithCoverageTrue"
          [value]="true"
          formControlName="withCoverage"
        />
        <label
          class="form-check-label"
          for="workedObjectExtendedWithCoverageTrue"
          >Oui</label
        >
      </div>
      <div
        *ngIf="
          metadataFormGroup.get('workedObjectExtendedCoverage.withCoverage')
            ?.value === 'true' ||
          metadataFormGroup.get('workedObjectExtendedCoverage.withCoverage')
            ?.value === true
        "
      >
        <label i18n>Somme d'assurance (CHF)</label>
        <input
          type="number"
          min="0"
          class="form-control mb-2"
          formControlName="insuredSum"
        />
        <label i18n>Franchise (CHF)</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Assurance actuelle
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Possède une assurance</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasInsurance"
          id="hasInsuranceFalse"
          [value]="false"
          formControlName="hasInsurance"
        />
        <label class="form-check-label" for="hasInsuranceFalse"> Non </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasInsurance"
          id="hasInsuranceTrue"
          [value]="true"
          formControlName="hasInsurance"
        />
        <label class="form-check-label" for="hasInsuranceTrue"> Oui </label>
      </div>
    </div>
    <div
      class="col"
      *ngIf="
        metadataFormGroup.value.hasInsurance === 'true' ||
        metadataFormGroup.value.hasInsurance === true
      "
    >
      <label i18n>Assureur actuel</label>
      <input
        type="text"
        class="form-control"
        formControlName="currentInsurer"
      />
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>A subi des sinistres ces 5 dernières années</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasClaimsLastFiveYears"
          id="hasClaimsLastFiveYearsFalse"
          [value]="false"
          formControlName="hasClaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasClaimsLastFiveYearsFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasClaimsLastFiveYears"
          id="hasClaimsLastFiveYearsTrue"
          [value]="true"
          formControlName="hasClaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasClaimsLastFiveYearsTrue">
          Oui
        </label>
      </div>
    </div>
  </div>
</ng-container>
